import React, { useState, useEffect } from 'react';

function DateDisplay( { dateVal } ) {
    const [date, setDate] = useState('');

    useEffect(() => {
        if (typeof dateVal !== 'undefined') {
            setDate(dateVal);
        }
    }, [dateVal]); // Runs when initialData changes

    const dateFromLong = (longDate) => {
        const re    = /^(\d{4}-\d{2}-\d{2})/;
        const m     = longDate.match(re);

        if (m) {
            return m[1];
        } else {
            return "";
        }
    }
    
    return(<>{dateFromLong(date)}</>);
}

export default DateDisplay;
